<template>
  <div>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row dense>
        <v-col cols="12" sm="12" md="12"
          ><v-banner
            color="blue-grey lighten-5"
            class="black--text"
            shaped
            single-line
          >
            Información personal
          </v-banner>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-row dense>
            <v-col cols="12" sm="4" md="4">
              <validation-provider
                v-slot="{ errors, valid }"
                name="Nombre"
                rules="required|max:60"
              >
                <v-text-field
                  :counter="60"
                  maxlength="60"
                  v-model.trim="generalInfoData.name"
                  label="Nombre*"
                  clearable
                  required
                  autocomplete="off"
                  :error-messages="errors"
                  dense
                  clear-icon="mdi-eraser"
                >
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid ? " mdi-check" : "" }}
                  </v-icon>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <validation-provider
                v-slot="{ errors, valid }"
                name="Primer apellido"
                rules="required|max:60|alpha|min:2"
              >
                <v-text-field
                  :counter="60"
                  maxlength="60"
                  v-model.trim="generalInfoData.firstLastname"
                  label="Primer apellido*"
                  clearable
                  required
                  autocomplete="off"
                  :error-messages="errors"
                  dense
                  clear-icon="mdi-eraser"
                >
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid ? " mdi-check" : "" }}
                  </v-icon>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <validation-provider
                v-slot="{ errors, valid }"
                name="Segundo apellido"
                rules="max:60|alpha|min:2"
              >
                <v-text-field
                  :counter="60"
                  maxlength="60"
                  v-model.trim="generalInfoData.secondLastname"
                  label="Segundo apellido (opcional)"
                  clearable
                  required
                  autocomplete="off"
                  :error-messages="errors"
                  dense
                  clear-icon="mdi-eraser"
                >
                  <v-icon
                    slot="append"
                    :color="
                      valid && generalInfoData.secondLastname ? 'warning' : ''
                    "
                  >
                    {{
                      valid && generalInfoData.secondLastname
                        ? " mdi-check"
                        : ""
                    }}
                  </v-icon>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-row dense>
            <v-col>
              <validation-provider
                v-slot="{ errors, valid }"
                name="Fecha nacimiento"
                rules="required"
              >
                <v-text-field
                  v-model.trim="generalInfoData.birthDate"
                  label="Fecha nacimiento*"
                  required
                  autocomplete="off"
                  :error-messages="errors"
                  dense
                  :max="new Date().toISOString().split('T')[0]"
                  type="date"
                >
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid ? " mdi-check" : "" }}
                  </v-icon>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider
                v-slot="{ errors, valid }"
                name="CURP"
                rules="required|max:18|min:18|curp"
              >
                <v-text-field
                  :counter="18"
                  maxlength="18"
                  minlength="18"
                  v-model.trim="generalInfoData.curp"
                  label="CURP*"
                  clearable
                  required
                  autocomplete="off"
                  :error-messages="errors"
                  dense
                  clear-icon="mdi-eraser"
                >
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid ? " mdi-check" : "" }}
                  </v-icon>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider
                v-slot="{ errors, valid }"
                name="Sexo"
                rules="required"
              >
                <v-select
                  :items="genders"
                  label="Sexo*"
                  clearable
                  required
                  autocomplete="off"
                  :error-messages="errors"
                  dense
                  clear-icon="mdi-eraser"
                  v-model.trim="generalInfoData.gender"
                >
                  <v-icon slot="append" :color="valid ? 'success' : ''">
                    {{ valid ? " mdi-check" : "" }}
                  </v-icon>
                </v-select>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="5" sm="5" md="5" offset-md="4">
              <h5 class="caption text--secondary">
                Si desconoce la CURP utiliza el formato XXXX999999XXXXXX99
              </h5>
            </v-col>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="12" md="12" align="center">
          <v-menu
            offset-x
            bottom
            left
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mr-12 mb-4"
                outlined
                color="error"
                depressed
                v-bind="attrs"
                v-on="{ ...menu }"
                @click="laststep()"
              >
                <v-icon left> mdi-keyboard-backspace </v-icon>
                paso anterior
              </v-btn>
            </template>
          </v-menu>
          <v-menu
            offset-x
            bottom
            rigth
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mb-4"
                :disabled="invalid"
                v-bind="attrs"
                depressed
                outlined
                v-on="{ ...menu }"
                color="primary"
                @click="nextstep()"
              >
                Siguiente paso
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-col>
      </v-row>
    </validation-observer>
  </div>
</template>

<script>
import {
  FederalEntityRequest,
  EnumRequest,
  SepomexRequest,
} from "@/core/request/";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  props: {
    generalInfoData: Object,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      genders: [
        { text: "Mujer", value: "M" },
        { text: "Hombre", value: "H" },
      ],
      /**validaciones */
      genericCurp: "XXXX999999XXXXXX99",
    };
  },
  watch: {
    nationality() {
      if (this.nationality !== "Otra") {
        this.generalInfoData.nationality = this.nationality;
      }
    },
    "generalInfoData.curp": function(val) {
      if (val == "" || val == null) {
        this.clearValidationFill();
      } else if (val.length == 18) {
        this.initCurpValidation();
      }
    },
  },
  
  methods: {
    /*** @MaudePallares ***/
    /***************************************************************************************** */
    /*** Validation funtions ***/
    /*** @MaudePallares ***/

    initCurpValidation() {
      this.gendervalidation();
      this.entityvalidation();
      // this.birthdatevalidation();
    },
    gendervalidation() {
      let validate = true;
      let curpgender = this.generalInfoData.curp;
      if (this.genericCurp == this.generalInfoData.curp) {
        validate = false;
        // this.genVal = false;
        this.generalInfoData.gender = null;
      }
      if (validate) {
        switch (curpgender.charAt(10)) {
          case "H":
            this.generalInfoData.gender = "H";
            // this.genVal = true;
            break;
          case "M":
            this.generalInfoData.gender = "M";
            // this.genVal = true;
            break;
          case "X":
            this.generalInfoData.gender = "X";
            // this.genVal = true;
            break;
        }
      }
    },
    entityvalidation() {
      let validate = true;
      let entityName = "";
      let entityCurp =
        this.generalInfoData.curp.charAt(11) +
        this.generalInfoData.curp.charAt(12);
      if (this.genericCurp == this.generalInfoData.curp) {
        validate = false;
      }
      if (validate) {
        for (let i in this.federalEntitiesBird) {
          if (this.federalEntitiesBird[i].entitykey == entityCurp) {
            entityName = this.federalEntitiesBird[i].text;
          }
        }
        this.generalInfoData.birthFederalEntity = entityName;
        this.entityVal = true;
      }
    },
    clearValidationFill() {
      this.generalInfoData.gender = "";
      this.generalInfoData.birthFederalEntity = "";
      this.generalInfoData.curp = "";
    },
    laststep() {
      this.$emit("laststep", 1);
    },
    nextstep() {
      this.$emit("nextstep", 3);
    },
  },
};
</script>
